import MainFeaturedPost from "../MainFeaturedPost";
import {CheckoutForm} from "./CheckoutForm";
import React, {useEffect, useState} from "react";
import {nanoid} from 'nanoid';
import * as _ from 'lodash';
import PartialCart from "../ShoppingCart/PartialCart";
import ScrollableTabsButtonAuto from "../ShoppingCart/ScrollableTabsButtonAuto";
import ScrollToCheckout from "../ScrollToCheckout";
import Fab from "@material-ui/core/Fab";
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import {useCommonStyles} from "../utils/commonStyles";
import CircularProgress from "@material-ui/core/CircularProgress";
import {GET_MENU_BY_BRANDNAME_ENDPOINT,} from "../Api/Contants";
import axios from "axios";
import {Redirect, useParams} from "react-router";
import PropTypes from "prop-types";
import Alert from "@material-ui/lab/Alert";
import {get_browser} from "../utils/utils";


export default function Menu({editMode, setNotify}) {

    const [orderNumber] = useState(nanoid());
    const [products, setProducts] = useState([]);
    const [submitting, setSubmitting] = useState(false);
    const [orderProducts, setOrderProducts] = useState([]);
    const [state, setState] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showAlert, setShowAlert] = useState(true);

    const { name } = useParams();
    function useNull() {
        return null;
    }
    const fetchMenu = async (name) => {
        const response = await axios.get(GET_MENU_BY_BRANDNAME_ENDPOINT + name).catch(useNull);
        return response.data;
    }

    useEffect(async () => {
        setShowAlert(get_browser().name === 'Safari');
        try {
            const data = await fetchMenu(name);
            setState(data);
            setProducts(_.filter(data.menu.products, (e) => {
                return e.enabled;
            }));
        }catch (e) {
        }
        setLoading(false);
    }, []);

    const onAddToCart = (product) => {
        product.added = true;
        let qty = product.quantity ? (product.quantity + 1): 1;
        product.quantity = qty;
        let exists = _.filter(orderProducts, (e) => {
            return e.id === product.id
        }).length>0;

        if(!orderProducts.length>0) {
            setOrderProducts(orderProducts => [...orderProducts, product]);
        }else {
            if (!exists){
                setOrderProducts(orderProducts => [...orderProducts, product]);
            }else{
                setOrderProducts(orderProducts => orderProducts.map((p) => {
                    return p.id === product.id ? product : p;
                }));
            }
        }
        setNotify({isOpen:true, message: 'Item agregado al carrito', type:'success'});
    }

    //Diminish one item
    const onRemoveFromCart = (product) => {
        let needsDeletion = !Math.max(0, product.quantity -1) > 0;
        if (needsDeletion) {
            onDeleteFromCart(product);
            return;
        }
        let qty = product.quantity-1;
        product.quantity = qty;
        setOrderProducts(orderProducts => orderProducts.map((p) => {
            return p.id === product.id ? product : p;
        }));

        setNotify({isOpen:true, message: 'Item eliminado al carrito', type:'info'});
    }

    //Completely delete item from cart
    const onDeleteFromCart = (product) => {
        product.added = false;
        product.quantity= 0;
        let copy = _.filter(orderProducts, (e) => {
            return e.id !== product.id
        });
        setOrderProducts(copy);
        setNotify({isOpen:true, message: 'Item eliminado del carrito', type:'info'});
    }

    const total = _.sum(orderProducts.map((product) => parseInt(product.quantity)*parseInt(product.price))) || 0;
    const classes = useCommonStyles();

    return (
        <>
            {!loading && state === null ? (<Redirect
                to={{
                    pathname: "/app",
                    state: { from: '/app/menu' }
                }}
            />):
            loading ? <div style={{textAlign: "center"}} className={classes.layout}><CircularProgress /></div>:
                (
                <>
                    <MainFeaturedPost
                        post={{
                            description: state.description,
                            image: state.image ? state.image : 'https://source.unsplash.com/featured/?shopping,business',
                            opening: state.opening,
                            category: state.category,
                            coin: state.coin,
                            address: state.address,
                            brandName: state.brandName,
                            open: state.open,
                            paymentInstructions: state.paymentInstructions,
                            phoneNumber: state.phoneNumber,
                            country: state.country
                        }}
                    />

                    <div className={classes.layout}>
                    <ScrollableTabsButtonAuto
                        products ={products}
                        onAddToCart={onAddToCart}
                        onRemoveFromCart={onRemoveFromCart}
                        submitting={submitting}
                        editMode={editMode}
                        setProductById={() => {}}
                    />
                    <PartialCart
                    products={orderProducts}
                    onDeleteFromCart={onDeleteFromCart}
                    />

                    {showAlert && <Alert severity="info">Asegúrate de permitir los Popups para poder enviar tu pedido por Whatsapp</Alert>}

                    <CheckoutForm
                        initialClient={{
                        firstName : '',
                        lastName: '',
                        phoneNumber: '',
                        deliveryType: '',
                        address1: '',
                        address2: '',
                        comment: '',
                        country: '',
                        date: (new Date(Date.now())).getDate()+ "/" + (new Date(Date.now())).getMonth() + "/" + (new Date(Date.now())).getFullYear(),
                        time: (new Date(Date.now())).toLocaleString('es', { hour: '2-digit', minute: '2-digit', hour12: true })
                        }}
                        order={{orderProducts, orderNumber, total, user:{
                                id: state.id,
                                minDelivery: state.minDelivery,
                                coin: state.userCoin.description,
                                deliveryCharge: state.deliveryCharge,
                                paymentInstructions: state.paymentInstructions,
                                phoneNumber: state.phoneNumber,
                                country: state.country
                            }}}
                        setSubmitting={setSubmitting}
                        userData={state}
                    />

                    <ScrollToCheckout>
                    <Fab color="primary" size="medium" aria-label="scroll back to top">
                    <ShoppingCartIcon />
                    </Fab>
                    </ScrollToCheckout>
                    </div>
                </>
                )
            }
        </>
    );
}

Menu.propTypes = {
    editMode: PropTypes.bool,
    setNotify: PropTypes.func,
};